import { CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './ghs-accordion.css.lit';
import { OutlineAccordion } from '../../base/outline-accordion/outline-accordion';

import { AccordionVariantType } from '../ghs-accordion-panel/ghs-accordion-panel';

/**
 * Accordion Component
 * @element ghs-accordion
 */
@customElement('ghs-accordion')
export class GhsAccordion extends OutlineAccordion {
  static styles: CSSResultGroup = [componentStyles];

  @property() variant: AccordionVariantType = 'primary';

  firstUpdated() {
    super.firstUpdated();

    this.panels.map(
      panel => (
        panel.setAttribute('variant', this.variant),
        panel.setAttribute('site-override', this.site)
      )
    );
  }
}
